import React from "react";
import { Span, Text } from "@catchoftheday/cg-components";
export const LinkedModalContent = ({ email }) => {
    return (<>
      <Text fontSize="base" fontWeight="medium" m={0}>
        You are currently logged in at Catch with{" "}
        <Span fontWeight="bold">{email}</Span>. This Catch account is already
        linked to a different OnePass account.
        <br />
        <br />
        Would you like to replace the current linking?
      </Text>
    </>);
};
export const UnlinkedModalContent = ({ email }) => {
    return (<>
      <Text fontSize="base" fontWeight="medium" mb={6}>
        We will link your OnePass and Catch accounts so you can access your
        member benefits at Catch. You are currently logged in at Catch with{" "}
        <Span fontWeight="bold">{email}</Span>
      </Text>
      <Text fontSize="xs" fontWeight="medium" m={0}>
        OnePass and the participating brands collect your purchasing and
        browsing history from each other and may provide you with personalised
        communications and advertising.
      </Text>
    </>);
};
